import React from 'react'
import Input from '@cloudscape-design/components-themed/input'

export function RadInput ({ ...rest }) {
  return (
    <Input {...rest} />
  )
}
